export default {

     //apidomain: 'http://l1.synapsys.lk:3239',
     //identityDomain: 'http://l1.synapsys.lk:5000',
     //reactDomain: 'http://l1.synapsys.lk:2786',
    apidomain: 'http://localhost:3239',
    identityDomain: 'http://localhost:5000',
    reactDomain: 'http://localhost:27866',
    idleTimeOut: 10 // Defined in minutes. More than 10 mins is preferred.
}

